/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { co_getplato_grid_acl_AclUser } from './co_getplato_grid_acl_AclUser';
import type { co_getplato_grid_api_domain_Address } from './co_getplato_grid_api_domain_Address';
import type { co_getplato_grid_api_domain_DraftOrderLineItem } from './co_getplato_grid_api_domain_DraftOrderLineItem';
export type co_getplato_grid_sales_SalDraftOrder = {
    draft_order_id: string;
    customer_id: string;
    sales_order_id?: string;
    state: co_getplato_grid_sales_SalDraftOrder.state;
    type?: string;
    clerk_id?: string;
    billing_address?: co_getplato_grid_api_domain_Address;
    shipping_address?: co_getplato_grid_api_domain_Address;
    contact_person_id?: string;
    contact_person_name?: string;
    due_date?: string;
    delivery_date?: string;
    shipping_type_id?: string;
    storage_id?: string;
    notes?: string;
    line_items: Array<co_getplato_grid_api_domain_DraftOrderLineItem>;
    total_amount: number;
    total_gross_margin: number;
    release?: boolean;
    external?: Record<string, any>;
    creator: co_getplato_grid_acl_AclUser;
    submitted_at?: string;
    created_at?: string;
};
export namespace co_getplato_grid_sales_SalDraftOrder {
    export enum state {
        NEW = 'NEW',
        SUBMITTED = 'SUBMITTED',
    }
}

